$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'

module.exports =
class Logo extends Singleton

  constructor: ->
    super

    @$loog = Elements.$logo
      .css 'display', 'none'

  show: ->
    @anime [1, 0], 'easeOutBack', 'block'

  hide: ->
    @anime [0, 1], 'easeInBack', 'none'

  anime: (scale, easing, display) ->
    @$loog.velocity
      scale: scale
    ,
      duration: 300
      easing  : easing
      display : display



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/logo.coffee